module.exports = __webpack_public_path__ + "img/pk.8e1b819c.svg";